import { StackFrame } from '../models/StackFrame';

export class StackFrameMapper {
  mapGQLModel(data: any, index: number): StackFrame {
    return new StackFrame(index, data.class || null, data.method || null, data.line !== null ? Number.parseInt(data.line, 10) : null, data.file || null);
  }
}
